import React, { FC } from 'react';
import styled from 'styled-components';
import { MoreDetailsButton, Name, Price } from '../../shared';
import { GuestProps } from '../guestProps';

const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;

const NamePrice = styled(Row)`
  padding-bottom: 16px;
`;

const MoreDetailsPrice = styled(Row)`
  padding-bottom: 24px;
`;

export const ExtraDetails: FC<GuestProps> = ({
  description,
  featured,
  hideDetails,
  isShowingDetails,
  name,
  price,
  pricePerNight,
  showDetails,
  showPrice,
  controls,
  pricingType,
  quantityLabel,
}) => {
  const priceElement = (
    <Price
      price={price}
      pricePerNight={pricePerNight}
      showPrice={showPrice}
      pricingType={pricingType}
      quantityLabel={quantityLabel}
    />
  );

  return (
    <>
      <NamePrice>
        <Name name={name} />
        {!featured && priceElement}
      </NamePrice>
      <MoreDetailsPrice>
        <MoreDetailsButton
          details={description}
          featured={featured}
          isShowingDetails={isShowingDetails}
          showDetails={showDetails}
          hideDetails={hideDetails}
          isWiderViewport={false}
        />
        {featured && priceElement}
      </MoreDetailsPrice>
      {controls}
    </>
  );
};
